import { HubConnectionBuilder } from "@microsoft/signalr";


const connection = new HubConnectionBuilder()
  .withUrl(process.env.VUE_APP_API_ROOT + "NotificationHub")
  .withAutomaticReconnect({nextRetryDelayInMilliseconds: () => 10000, reconnectDelay: 5000})
  .build();

export { connection }